module.exports = __webpack_public_path__ + "img/content9.914c16f3.png";